import React from "react";
import { Navigate } from "react-router-dom";
import useUser from "../hooks/useUser"; // ajusta la ruta si es necesario

export default function RutaProtegida({ children }) {
  const user = useUser();

  if (!user || typeof user.id_area === "undefined") {

    return null; // o un spinner si prefieres mostrar algo mientras carga

  }

  if (user.id_area !== 1) {

    return <Navigate to="/acceso-denegado" replace />;
    
  }

  return children;
}